import { ComponentType } from 'react';
import type { ProductTestRatingComponentProps } from './product-test-rating.component';
import dynamic from 'next/dynamic';

export const DynamicProductTestRatingComponent: ComponentType<ProductTestRatingComponentProps> =
  dynamic(() => import('./product-test-rating.component'), {
    loading: () => null
  });
